<template>
  <div :class="modalTheme">
    <h3 v-if="AreIdsShown">other TEST</h3>
    <div :class="userStore.borderClass">
      <h3 v-if="AreIdsShown">other TEST</h3>
      <!-- <h3>currentlySelectedRecords {{ currentlySelectedRecords }}</h3> -->
      <!-- <h6 v-if="AreIdsShown" style="background:darkred;color:cyan;">PIE: selectedWidgetFilter {{ selectedWidgetFilter }}
		</h6>
		<h4 v-if="AreIdsShown" style="background:darkgreen;color:lime;">filterDummyGrid(this.workwidgetArray)
			{{ filterDummyGrid.length }}</h4> -->
      <!-- <h4 v-if="AreIdsShown" style="background:darkgoldenrod;color:yellow;">this.workwidgetArray{{ workwidgetArray.length }}</h4> -->
      <h5 v-if="AreIdsShown" style="background: darkgreen; color: yellow">INC records{{ records.length }}</h5>
      <h5 v-if="AreIdsShown" style="background: darkgreen; color: yellow">INC arrayId {{ arrayId }}</h5>

      <h6 v-if="AreIdsShown" style="background: red; color: white">selectedFileName {{ selectedFileName }}</h6>

      <!-- filterDummyGrid = {{filterDummyGrid}} -->

      <div>
        <h6 v-if="AreIdsShown">WidgetOtherRecordSelector</h6>
        <h5 v-if="AreIdsShown">TODO add EVENT @recordsSelected="recordsSelectedWidgetOtherWork"</h5>
      </div>

      <WidgetOtherRecordSelector
        idField="id"
        :records="workListStore.workwidgetArray"
        :selectedFileName="selectedFileName"
        :selected="currentlySelectedRecords"
        @recordsSelected="recordsSelectedWidgetWorkLocal"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

import { useStoreWorkList } from "@/stores/workListsStore";
import WidgetOtherRecordSelector from "@/modules/WorkLists/WidgetOtherRecordSelector.vue";

// & COMPOSIBLEs
import { discreteDataDashMixin } from "@/use/discreteDataDashMixin.js";

// & PROPS
const props = defineProps({
  records: {
    type: Object,
    default: () => {},
  },
  selectedFileName: {
    type: String,
    default: () => {},
  },
  arrayId: {
    type: Number,
    default: () => {},
  },
});

const modalTheme = computed(() => userStore.bModalTheme);

const AreIdsShown = ref(false);
const workListStore = useStoreWorkList();

function recordsSelectedWidgetWorkLocal(ids) {
  // console.log("recordsSelectedWidgetWorkFFRROMddMixN");
  // console.log("				GOES to discreteDATA MIXINS");
  // console.log();
// console.log("ids");
// console.log(ids);
// console.log(" SEND ids TO   USE     discDataDASHMinx  ");

// console.log("   FAAAIL   FAIL discDataDASHMinx             recordsSelectedWidgetWork");
  //  const xxx = recordsSelectedWidgetWork(ids);

  const { recordsSelectedWidgetOtherWork } = discreteDataDashMixin(ids);

  const xxx = recordsSelectedWidgetOtherWork(ids);
// console.log("xxx");
// console.log(xxx);

// console.log();
}

// function filterDummyGrid() {
//   // console.clear()
//   console.log("GRID       WORK 				filterDummyGrid  workListStore.workwidgetArray");
//   console.log(workListStore.workwidgetArray);

//   console.log("			tempRecords.filter(");
//   const tempRecords = workListStore.workwidgetArray;

//   console.log("workListStore.selectedWidgetFilter");
//   console.log(workListStore.selectedWidgetFilter);

//   if (workListStore.selectedWidgetFilter !== "") {
//     return tempRecords.filter((record) => record.dueText == workListStore.selectedWidgetFilter);
//   } else {
//     return tempRecords;
//   }
// }

onMounted(() => {
// console.log("onMounted() :      WidgetSummaryDetailOtherGrid >>>>");
//  console.log("props : ");
//  console.log(props);
//  console.log(" prop   records ");
//  console.log(props.records);
});
</script>

<style lang="scss" scoped>
@import "./worklistStyling.scss";

.dx-toolbar .dx-toolbar-items-container {
  height: 0rem !important;
}

.scroll-container,
.scroll-area {
  //max-width: 150px;
  height: 45px * 2;
  max-height: 45px * 4;
  //font-size: 30px;32
}

.scroll-container {
  overflow: auto;
  scroll-snap-type: y mandatory;
}

.scroll-area {
  scroll-snap-align: start;
}

.detailsSlot {
  border: 3px solid transparent;
}

.scroll-container,
.scroll-area {
  margin: 0 auto;
}

.scroll-area {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.scroll-area:nth-of-type(1) {
  background: #49b293;
}

.scroll-area:nth-of-type(2) {
  background: #c94e4b;
}

.scroll-area:nth-of-type(3) {
  background: #4cc1be;
}

.scroll-area:nth-of-type(4) {
  background: #8360a6;
}
</style>
